import * as UniversalAnalytics from 'vue-analytics';
import * as GTag from 'vue-gtag';
import AppConfig from './AppConfig';

export interface IAnalyticsMethods {
	event: (eventCategory: string, eventAction: string, eventLabel: string, eventValue: number) => void;
	page: (page: string, title?: string, location?: string) => void;
}

export interface ITrackEvent {
	track: (va: IAnalyticsMethods) => void;
}

export class ActionTracker {
	public track (trackEvent: ITrackEvent): void {
		if (this.enabled) {
			trackEvent.track(this);
		}
	}

	public get enabled (): boolean {
		return this.gtagAnalyticsEnabled || this.uaAnalyticsEnabled;
	}

	private get gtagAnalyticsEnabled () {
		return (AppConfig.gtagAnalyticsPropertyId || '') !== '';
	}

	private get uaAnalyticsEnabled () {
		return !this.gtagAnalyticsEnabled && (AppConfig.googleAnalyticsTrackingId || '') !== '';
	}

	public event (eventCategory: string, eventAction: string, eventLabel: string, eventValue: number): void {
		if (this.gtagAnalyticsEnabled) {
			GTag.event(eventAction, {
				event_label: eventLabel,
				event_category: eventCategory,
				value: eventValue
			});
		}

		if (this.uaAnalyticsEnabled) {
			UniversalAnalytics.event(eventCategory, eventAction, eventLabel, eventValue);
		}
	}

	public page (page: string, title?: string, location?: string): void {
		if (this.gtagAnalyticsEnabled) {
			GTag.pageview({
				page_location: location,
				page_path: page,
				page_title: title
			});
		}

		if (this.uaAnalyticsEnabled) {
			UniversalAnalytics.page(page, title, location);
		}
	}
}

export default new ActionTracker();
